// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1EK2I","fileBtn":"File_fileBtn__1y-d3","closeBtn":"File_closeBtn__1G-zC","fileSelected":"File_fileSelected__6CqGI","disabled":"File_disabled__O8CzD"};